<template>
  <div class="auth">
    <form 
      class="auth__form" 
      @submit.prevent="submitSignup">
      <div class="auth__form__section auth__header">
        <h1 class="auth__title">
          Welcome!
        </h1>
        <h4 class="auth__subtitle">
          Signup below to get started
        </h4>
      </div>
      <hr class="auth__hr" >
      <div class="auth__form__section">
        <R64Input
          id="first_name"
          v-model="signupForm.first_name"
          :state="inputState($v.signupForm.first_name)"
          type="text"
          placeholder="First name"
          invalid-message="First name is required"
          @blur="$v.signupForm.first_name.$touch()" />
        <R64Input
          id="last_name"
          v-model="signupForm.last_name"
          :state="inputState($v.signupForm.last_name)"
          type="text"
          placeholder="Last name"
          invalid-message="Last name is required"
          @blur="$v.signupForm.last_name.$touch()" />
        <R64Input
          id="email"
          v-model="signupForm.email"
          :state="inputState($v.signupForm.email)"
          type="text"
          placeholder="Email address"
          invalid-message="Valid email address is required"
          @blur="$v.signupForm.email.$touch()" />
        <R64Input
          id="password"
          v-model="signupForm.password"
          :state="inputState($v.signupForm.password)"
          type="password"
          placeholder="Password"
          invalid-message="Valid password is required"
          @blur="$v.signupForm.password.$touch()" />
          
        <p 
          v-if="serverValidationError" 
          class="invalid-feedback">
          {{ serverValidationError }}
        </p>
        <div class="auth__buttons">
          <router-link
            :to="{ name: 'UserLogin' }"
            class="auth__buttons__link">
            Already registered?
          </router-link>
          <button 
            class="button button-green" 
            type="submit">
            Signup
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import R64Input from '@/components/r64/R64Input'
import { email, required } from 'vuelidate/lib/validators'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'UserSignup',

  components: {
    R64Input
  },

  data() {
    return {
      signupForm: {
        first_name: '',
        last_name: '',
        email: '',
        password: ''
      },
      serverValidationError: null
    }
  },

  computed: {
    ...mapState({
      loggedIn: state => state.auth.loggedIn
    })
  },

  validations: {
    signupForm: {
      first_name: {
        required
      },

      last_name: {
        required
      },

      email: {
        required,
        email
      },

      password: {
        required
      }
    }
  },

  methods: {
    ...mapActions({
      signup: 'auth/signup'
    }),

    submitSignup() {
      this.$v.$touch()

      if (this.$v.$error) {
        return
      }

      this.signup(this.signupForm)
        .then(() => {
          this.serverValidationError = null
          /*
          this.$router.push({
            name: 'MyCourses'
          })
          */
        })
        .catch(errorResult => {
          this.serverValidationError = errorResult.error
        })
    }
  },

  metaInfo: {
    title: 'Signup'
  }
}
</script>
